/* =========================================================
   sports&deco — Parser TCX (format Garmin Training Center)
   ========================================================= */

function parseTCX(text) {
  const xml = new DOMParser().parseFromString(text, 'application/xml');
  const err = xml.querySelector('parsererror');
  if (err) throw new Error('TCX: XML invalide');

  const trackpoints = Array.from(xml.getElementsByTagName('Trackpoint'));
  if (!trackpoints.length) throw new Error('TCX: aucun trackpoint');

  const samples = trackpoints.map((tp) => {
    const pos = tp.getElementsByTagName('Position')[0];
    if (!pos) return null;
    const lat = parseFloat(pos.getElementsByTagName('LatitudeDegrees')[0]?.textContent);
    const lon = parseFloat(pos.getElementsByTagName('LongitudeDegrees')[0]?.textContent);
    const eleEl = tp.getElementsByTagName('AltitudeMeters')[0];
    const timeEl = tp.getElementsByTagName('Time')[0];
    return {
      lat,
      lon,
      ele: eleEl ? parseFloat(eleEl.textContent) : null,
      time: timeEl ? new Date(timeEl.textContent) : null,
    };
  }).filter((p) => p && Number.isFinite(p.lat) && Number.isFinite(p.lon));

  const activity = xml.getElementsByTagName('Activity')[0];
  const sportRaw = activity ? activity.getAttribute('Sport') : null;
  const idEl = activity?.getElementsByTagName('Id')[0];

  return {
    sourceFormat: 'tcx',
    name: null,
    sportRaw,
    activityId: idEl ? idEl.textContent : null,
    samples,
  };
}
